import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import {
  FaCheck,
  FaCheckCircle,
  FaExclamationTriangle,
  FaPencilAlt,
  FaTimes,
  FaTimesCircle
} from 'react-icons/fa';
import { BiSolidBarChartAlt2 } from 'react-icons/bi';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Confirm from '../../components/UI/Confirm/Confirm';
import SpecReadyConfirm from '../../components/UI/Confirm/SpecReadyConfirm';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Switch from '../../components/UI/Switch/Switch';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import classes from './NetworkInfo.css';


export class NetworkInfo extends Component {
  state = {
    showEditSSID: false,
    showEditPwd: false,
    upArrows: true,
    success: false,
    serviceRestoreSuccess: false,
    error: false,
    confirmModal: false,
    specReadyConfirmModal: false,
    action: null,
    result: null,
    viewPass: false,
    viewConfPass: false,
    originalName: this.props.originalName,
    originalPassword: this.props.originalPassword,
    isInvalidSSID: false,
    isInvalidPassword: false,
    specReadyToggle: null,
    controls: {
      name: {
        elementType: 'input',
        elementConfig: {
          type: 'Name',
          placeholder: 'Name',
        },
        value: this.props.realSettings['2ghz_wifi'].subscriber.ssid
          ? this.props.realSettings['2ghz_wifi'].subscriber.ssid
          : this.props.originalName,
        validation: {
          required: true,
          isName: true,
        },
        valid: false,
        touched: false,
      },
      password: {
        elementType: 'input',
        elementConfig: {
          type: 'password',
          placeholder: 'Password',
        },
        value: this.props.realSettings['2ghz_wifi'].subscriber.passphrase
          ? this.props.realSettings['2ghz_wifi'].subscriber.passphrase
          : this.props.originalPassword,
        validation: {
          required: true,
          minLength: 6,
        },
        valid: false,
        touched: false,
      },
      confirmPassword: {
        elementType: 'input',
        elementConfig: {
          type: 'password',
          placeholder: 'Password',
        },
        value: this.props.realSettings['2ghz_wifi'].subscriber.passphrase
          ? this.props.realSettings['2ghz_wifi'].subscriber.passphrase
          : this.props.originalPassword,
        validation: {
          required: true,
          minLength: 6,
        },
        valid: false,
        touched: false,
      },
    },
  };

  componentWillMount() { }
  componentDidMount() {
    let dwell = sessionStorage.getItem('specReadOn');
    // console.log('NET IN DID MOUNT', dwell);
    let isSpecReadyOn = dwell === 'SPECREADON' ? true : false;
    // console.log('is on???', isSpecReadyOn);
    if (isSpecReadyOn) {
      this.props.onInitConnectivity();
    }
  }

  componentWillUpdate() { }
  componentDidUpdate(prevState) {
    if (prevState.originalName !== this.props.originalName
      || prevState.originalPassword !== this.props.originalPassword) {
      this.setState({
        showEditSSID: false,
        showEditPwd: false,
        viewConfPass: false,
        viewPass: false,
        originalName: this.props.originalName,
        originalPassword: this.props.originalPassword
      })
    }
    if (
      this.state.specReadyToggle === null &&
      (this.props.specReadyConnectivity === true ||
        this.props.specReadyConnectivity === false)
    ) {
      this.setState({
        specReadyToggle: this.props.specReadyConnectivity,
      });
    }
  }
  openHandler() {
    this.setState({
      upArrows: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrows: false,
    });
  }
  viewPassToggle() {
    this.setState({
      viewPass: this.state.viewPass ? false : true,
    });
  }
  viewConfPassToggle() {
    this.setState({
      viewConfPass: this.state.viewConfPass ? false : true,
    });
  }
  isNotValidAlphaNumeric(value) {
    const pattern = /^[a-zA-Z0-9]*$/;
    return !pattern.test(value);
  }
  toggleEditSSID = () => {
    this.setState({ showEditSSID: !this.state.showEditSSID });
  };
  cancelPwd = () => {
    let ssidPwd = this.props.realSettings['2ghz_wifi'].subscriber.passphrase
      ? this.props.realSettings['2ghz_wifi'].subscriber.passphrase
      : this.props.originalPassword;
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        password: {
          ...prevState.controls.password,
          value: ssidPwd,
        },
      },
    }));
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        confirmPassword: {
          ...prevState.controls.confirmPassword,
          value: ssidPwd,
        },
      },
    }));

    this.setState({ isInvalidPassword: false });
    this.setState({ showEditPwd: !this.state.showEditPwd });
  };
  cancelSSID = () => {
    let ssidName = this.props.realSettings['2ghz_wifi'].subscriber.ssid
      ? this.props.realSettings['2ghz_wifi'].subscriber.ssid
      : this.props.originalName;
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        name: {
          ...prevState.controls.name,
          value: ssidName,
        },
      },
    }));

    this.setState({ isInvalidSSID: false });
    this.setState({ showEditSSID: !this.state.showEditSSID });
  };
  toggleEditPwd = () => {
    this.setState({ showEditPwd: !this.state.showEditPwd });
    this.setState({ viewPass: false });
    this.setState({ viewConfPass: false });
  };
  isValidSsid(value) {
    var ssidRegex = new RegExp(
      '^((?=.*[a-z])|(?=.*[A-Z])|(?=.*[0-9])|(?=.*[!@#%\\*:\\[~(_)\\-+={}|,.?/ \'\\]]))(?!.*[\\^\\\\><;`"$&])'
    );
    //console.log("ssid pattern", value, "?", ssidRegex.test(value));
    if (/\s+$/.test(value) || /^\s/.test(value) || /\s{2,}/g.test(value)) {
      // this.setState({ isInvalidSSID: true})
      return false;
    } else return ssidRegex.test(value);
  }
  isValidPassword(value) {
    var passwordRegex = new RegExp(
      '^((?=.*[a-z])|(?=.*[A-Z])|(?=.*[0-9])|(?=.*[!@#%*:\\[~(_)\\-+={}|,.?/ \\]]))(?!.*[\\^\\\\><;`"$&\'])'
    );
    //console.log("password pattern", value, "?", passwordRegex.test(value));
    if (/\s+$/.test(value) || /^\s/.test(value) || /\s{2,}/g.test(value)) {
      return false;
    } else return passwordRegex.test(value);
  }
  handleNameChange = (e) => {
    let myValue = e.target.value;
    let res;
    res = myValue.match('^[^<>$`\\\\^&;"]+$');
    if (res == null) {
      this.setState({ isInvalidSSID: true });
    } else if (/\s+$/.test(myValue) || /^\s/.test(myValue) || /\s{2,}/g.test(myValue)) {
      this.setState({ isInvalidSSID: true });
    } else {
      this.setState({ isInvalidSSID: false });
    }
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        name: {
          ...prevState.controls.name,
          value: myValue,
        },
      },
    }));
  };

  handlePasswordChange = (e) => {
    let myValue = e.target.value;
    let res;
    res = myValue.match('^[^<>$`\\\\^&;"\']+$');
    if (res == null) {
      this.setState({ isInvalidPassword: true });
    } else if (/\s+$/.test(myValue) || /^\s/.test(myValue) || /\s{2,}/g.test(myValue)) {
      this.setState({ isInvalidPassword: true });
    } else {
      this.setState({ isInvalidPassword: false });
    }
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        password: {
          ...prevState.controls.password,
          value: myValue,
        },
      },
    }));
  };
  handleConfirmPasswordChange = (e) => {
    let myValue = e.target.value;

    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        confirmPassword: {
          ...prevState.controls.confirmPassword,
          value: myValue,
        },
      },
    }));
  };
  submitNameChangeHandler = (event) => {
    this.setState({ confirmNameModal: true, action: 'change your WiFi network name (SSID)' });
  };
  confirmModalConfirmHandler = () => {
    if (this.state.action === 'change your WiFi network name (SSID)') {
      this.props.onChangeNamePass(
        this.state.controls.name.value,
        this.state.originalPassword,
        'n'
      );
    }
    if (this.state.action === 'Change your WiFi network password?') {
      this.props.onChangeNamePass(
        this.props.originalName,
        this.state.controls.password.value,
        'p'
      );
    }
    this.confirmModalCancelHandler('cancel');
  };
  confirmModalCancelHandler = (flag) => {
    this.setState({ confirmModal: false, confirmNameModal: false });
    // console.log(this.state.action);
    if (flag !== 'cancel') {
      if (this.state.action === 'change your WiFi network name (SSID)') {
        this.cancelSSID();
      }

      if (this.state.action === 'Change your WiFi network password?') {
        this.cancelPwd();
      }
    }
  };
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false, serviceRestoreSuccess: false });
    this.props.onResetSettingsErrorSuccess();
  };
  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };
  onOpenSpecReadyModal = (value) => {
    this.setState({
      specReadyConfirmModal: true,
      specReadyToggle: value,
    });
  };
  specReadyConfirmModalCancelHandler = () => {
    this.setState({
      specReadyConfirmModal: false,
      specReadyToggle: this.state.specReadyToggle ? false : true,
    });
  };
  specReadyConfirmModalConfirmHandler = () => {
    this.setState({
      specReadyConfirmModal: false,
    });

    // console.log('toggle time', this.state.specReadyToggle);
    if (this.state.specReadyToggle === false) {
      // console.log('Move out time');
      this.props.onMoveOut();
    } else {
      this.props.onMoveIn();
    }
  };
  handleSpecReadyToggle = (value) => {
    this.onOpenSpecReadyModal(value);
  };
  submitPasswordHandler = (event) => {
    this.onOpenModal(
      'This will require you to reconnect all devices using the new WiFi network password.',
      'Change your WiFi network password?'
    );
  };

  getConfirmationModalForDisconnected = () => {
    return (
      <div className={classes.disconnectedModalContainer}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FaExclamationTriangle
            id='DSAlertIcon'
            color={'red'}
            fontSize={'35px'}
            style={{ marginRight: '5px', marginTop: '8px' }} />
          <h2>Router Offline</h2>
        </div>
        <div id="RouterOfflineAlertSSID" className={classes.title}>Router is offline. Configuration changes will update when router is back online.</div>
        <button
          visibility='true'
          className={classes.RegularButton}
          onClick={this.confirmModalCancelHandler}
          id="ssidalertokbutton"
        >
          OK
        </button>
      </div>
    )
  }

  getConfirmNameModalBody = () => {
    return (
      <div className={classes.modalContainer}>
        <FaExclamationTriangle
          id='SSIDIcon'
          color={'#ecb900'}
          fontSize={'30px'}
          style={{ marginBottom: 20 }}
        />
        <div id='SSIDWarning' className={classes.title}>Warning! This will require you to reconnect all  devices using the new WiFi Network name. <br /> </div>
        <div id='SSIDNote' className={classes.errorText}>Note: Devices using MAC randomization will lose detail for username, pause schedules,
          IP reservations, groups and port forwarding. Devices that use MAC randomization will have
          duplicate entries in device list upon reconnecting device.</div>
        <div id='SSIDConfirm' className={classes.title}>Are you sure you want to change your WiFi network name (SSID)?</div>
        <Confirm
          hideContent
          cancelId='SSIDCancel'
          confirmlId='SSIDProceed'
          confirm={this.confirmModalConfirmHandler}
          cancel={this.confirmModalCancelHandler}
          deviceGroupConfirmation
        />
      </div>
    )
  }

  render() {
    const isWiFiDisabled = sessionStorage.getItem("featureFlags")?.includes('staticIP') && this.props.staticIPConfigData?.expectedResults?.customerPrefConfigType?.includes('STATIC-DHCP-NAT-WIRELESS') === false;
    const isBroadcasting = isWiFiDisabled && !this.props.broadcastSettingsData?.['2ghz_wifi']?.subscriber?.broadcast;
    let eyePass, eyeConfPass;
    let passInput;
    let confPassInput;
    let ssid;
    let { showEditSSID, showEditPwd } = this.state;
    if (this.props.error && !this.state.error) {
      this.setState({ error: true });
      this.props.onResetSettingsErrorSuccess();
    }
    if (this.props.success && !this.state.success) {
      this.setState({ success: true });
      this.props.onResetSettingsErrorSuccess();
    }
    if (this.props.serviceRestoreSuccess && !this.state.serviceRestoreSuccess) {
      this.setState({ serviceRestoreSuccess: true });
      this.props.onResetSettingsErrorSuccess();
    }

    if (this.state.viewPass && this.props.realSettings) {
      ssid = this.props.realSettings['2ghz_wifi'].subscriber;
      passInput = (
        <input
          className={classes.NetworkInfoInput}
          type="text"
          id="pass"
          name="password"
          aria-label="password"
          style={
            this.props.realSettings.fake && this.props.isDummy
              ? { color: 'pink' }
              : {}
          }
          minLength="8"
          maxLength="29"
          required
          value={this.state.controls.password.value}
          onChange={this.handlePasswordChange}
        />
      );
      eyePass = <span className={classes.ShowPwd}>Hide</span>;
    } else if (!this.state.viewPass && this.props.realSettings) {
      ssid = this.props.realSettings['2ghz_wifi'].subscriber;

      passInput = (
        <input
          className={classes.NetworkInfoInput}
          type="password"
          id="pass"
          aria-label="wifi password"
          name="password"
          style={
            this.props.realSettings.fake && this.props.isDummy
              ? { color: 'pink' }
              : {}
          }
          minLength="8"
          maxLength="29"
          required
          defaultValue={this.state.controls.password.value}
        />
      );
      eyePass = (
        <span id="show" className={classes.ShowPwd}>
          Show
        </span>
      );
    }

    if (this.state.viewConfPass && this.props.realSettings) {
      ssid = this.props.realSettings['2ghz_wifi'].subscriber;
      confPassInput = (
        <input
          className={classes.NetworkInfoInput}
          type="text"
          id="confirmPass"
          name="confirmPassword"
          aria-label="wifi confirm password"
          minLength="8"
          maxLength="29"
          required
          value={
            this.state.controls.confirmPassword.value
              ? this.state.controls.confirmPassword.value
              : null
          }
          onChange={this.handleConfirmPasswordChange}
        />
      );
      eyeConfPass = <span className={classes.ShowPwd}>Hide</span>;
    } else if (!this.state.viewConfPass && this.props.realSettings) {
      confPassInput = (
        <input
          className={classes.NetworkInfoInput}
          type="password"
          id="confirmPass"
          name="confirmPassword"
          aria-label="wifi confirm password"
          minLength="8"
          maxLength="29"
          required
          defaultValue={
            this.state.controls.confirmPassword.value
              ? this.state.controls.confirmPassword.value
              : null
          }
        />
      );
      eyeConfPass = (
        <span id="showconf" className={classes.ShowPwd}>
          Show
        </span>
      );
    }
    let specReadySwitch;
    let specReadySymbol;

    let dwell = sessionStorage.getItem('specReadOn');
    let isSpecReadyOn = dwell === 'SPECREADON' ? true : false;
    if (
      isSpecReadyOn &&
      (this.props.specReadyConnectivity === true ||
        this.props.specReadyConnectivity === false)
    ) {
      if (this.props.specReadyConnectivity === false) {
        specReadySymbol = (
          <FaExclamationTriangle
            color={'red'}
            fontSize={'30px'}
            style={{ marginRight: '10px' }}
          />
        );
      } else {
        specReadySymbol = (
          <FaCheckCircle
            color={'green'}
            fontSize={'30px'}
            style={{ marginRight: '10px' }}
          />
        );
      }

      specReadySwitch = (
        <div>
          <b>Spectrum Ready Service</b>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {specReadySymbol}
              <span id="spectrumready">WiFi and Router Ports</span>
            </div>

            <Switch
              onChange={this.handleSpecReadyToggle}
              checked={this.state.specReadyToggle} //for now
            />
          </p>
          <div className={classes.Spacer}></div>
        </div>
      );
    } else {
      specReadySwitch = <div />;
    }
    let connection;
    let custId = this.props?.tenantData?.accountNumber || sessionStorage.getItem('accountNumber') ||null ;
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrows) {
      arrow = (
        <MdKeyboardArrowUp aria-label="arrow up" color={'gray'} size={'30px'} />
      );
    } else {
      arrow = (
        <MdKeyboardArrowDown
          aria-label="arrow down"
          color={'gray'}
          size={'30px'}
        />
      );
    }
    //this.props.realWan.connectionState = undefined;
    if (this.props.checkingWan) {
      connection = (
        <p id="NetworkStatus" style={{ display: 'flex', alignItems: 'center' }}>
          <FaTimesCircle
            color={'#d6312b'}
            fontSize={'30px'}
            style={{ marginRight: '10px' }}
          />
          Disconnected
        </p>
      );
    } else if (
      this.props.realWan &&
      this.props.realWan.connectionState &&
      this.props.realWan.connectionState === 'connected'
    ) {
      connection = (
        <p id="NetworkStatus" style={{ display: 'flex', alignItems: 'center' }}>
          <FaCheckCircle
            color={'green'}
            fontSize={'30px'}
            style={{ marginRight: '10px' }}
          />
          Connected
        </p>
      );
    } else if (
      this.props.realWan &&
      this.props.realWan.connectionState &&
      this.props.realWan.connectionState === 'disconnected'
    ) {
      connection = (
        <p id="NetworkStatus" style={{ display: 'flex', alignItems: 'center' }}>
          <FaTimesCircle
            color={'#d6312b'}
            fontSize={'30px'}
            style={{ marginRight: '10px' }}
          />
          Disconnected
        </p>
      );
    } else {
      // realWan.connectionState property is undefined, " " & "unavailable", displaying N/A
      connection = <p style={{ display: 'flex', alignItems: 'center' }}>N/A</p>;
    }
    if (!this.props.realSettings || !this.props.realWan) {
      return (
        <Box>
          <h3>Account & Network Info</h3>

          <div id = 'NetworkInfoTxt' style={{ color: 'gray' }}>
            Something went wrong. There is limited network information available at this time.
          </div>
        </Box>
      );
    } else if (
      this.props.settingsLoading ||
      !this.props.settingsLoaded ||
      this.props.wanLoading ||
      !this.props.wanLoaded
    ) {
      return <Spinner />;
    } else {
      // this.props.realWan.wanIp = "";
      // this.props.realWan.publicIp =  undefined;
      return (
        <Collapsible
          open={true}
          transitionTime={100}
          onOpening={() => {
            this.openHandler();
          }}
          onClosing={() => {
            this.closeHandler();
          }}
          trigger={
            <Box>
              <div>
                <div className={classes.TableRow}>
                  <h3>Account & Network Info</h3>
                  <button className={classes.OpenCloseButton}>{arrow}</button>
                </div>
              </div>
            </Box>
          }
        >
          <div>
            <b>Account Number</b>
            <p id="AccountNumberdata">{custId}</p>
            <div className={classes.Spacer}></div>
            <b>Network Status </b>
            {connection}
            <div className={classes.Spacer}></div>
            {/* {specReadySwitch} */}
            <b>Public IP Address</b>
            <p id="PublicIP">
              {this.props.realWan.wanIp || this.props.realWan.publicIp || 'N/A'}
            </p>

            {/* <p>Public IPV6 Address:</p>
          <b>{this.props.realWan.ipv6?this.props.realWan.ipv6:'N/A'}</b> */}
            <div className={classes.Spacer}></div>

            <b>WiFi Network Name (SSID)</b>
            <button
              id="EditSSID"
              aria-label="Edit SSID"
              className={!showEditSSID ? '' : classes.HideEditSSID}
              style={{ background: 'none', border: 'none' }}
              onClick={this.toggleEditSSID}
            >
              <FaPencilAlt color={'gray'} />
            </button>
            <p
              id="SSIDName"
              className={!showEditSSID ? '' : classes.HideEditSSID}
              style={{ whiteSpace: 'pre' }}
            >
              {this.props.realSettings['2ghz_wifi'].subscriber.ssid
                ? this.props.realSettings['2ghz_wifi'].subscriber.ssid
                : this.props.originalName}
            </p>
            <div className={showEditSSID ? '' : classes.HideEditSSID}>
              <div>
                <input
                  className={classes.NetworkInfoInputWifiName}
                  id="WIFIName"
                  type="text"
                  name="wifiName"
                  aria-label="WiFi name"
                  value={this.state.controls.name.value}
                  minLength="3"
                  maxLength="32"
                  required
                  onChange={this.handleNameChange}
                />

                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '0px',
                    paddingLeft: '5px',
                  }}
                  onClick={this.submitNameChangeHandler}
                  id="saveWifiName"
                  title="Change Name"
                  disabled={
                    this.state.controls.name.value.length <= 2 ||
                    this.state.controls.name.value.length >= 33 ||
                    !this.isValidSsid(this.state.controls.name.value) ||
                    this.state.controls.name.value === this.state.originalName ||
                    this.state.controls.name.value.toLowerCase() === 'spectrum mobile'
                  }
                >
                  <FaCheck color={this.state.controls.name.value.length <= 2 ||
                    this.state.controls.name.value.length >= 33 ||
                    !this.isValidSsid(this.state.controls.name.value) ||
                    this.state.controls.name.value.toLowerCase() === 'spectrum mobile' ||
                    this.state.controls.name.value === this.state.originalName ? 'grey' : 'green'} />
                </button>

                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '6px 5px 10px 5px',
                  }}
                  onClick={this.cancelSSID}
                  id="cancelWifiName"
                  title="Cancel Name"
                >
                  <FaTimes color={'red'} />
                </button>

                <div
                  id="SSIDErrorMsg"
                  style={
                    this.state.isInvalidSSID
                      ? { color: 'red', fontSize: 12 }
                      : { display: 'none' }
                  }
                >
                  Space is only allowed in between the characters. The following
                  characters are not allowed $ {'<'} {'>'} ` \ ^ & ; "
                </div>
                {
                  (this.state.controls.name.value.toLowerCase() === 'spectrum mobile') ?
                  <div
                  style={{color: 'red', fontSize: 12}}
                >
                  { `Invalid Value. SSID may not be '${this.state.controls.name.value}'`}
                </div> : <div />
                }
              </div>
              <div className={classes.Helper}>3-32 characters</div>
              <div className={classes.Spacer}></div>
            </div>

            <b>WiFi Password</b>
            <button
              id="editpassword"
              aria-label="Edit Password"
              className={!showEditPwd ? '' : classes.HideEditPwd}
              style={{ background: 'none', border: 'none' }}
              onClick={this.toggleEditPwd}
            >
              <FaPencilAlt color={'gray'} />
            </button>
            <p className={!showEditPwd ? '' : classes.HideEditPwd}>
              <input
                className={classes.NetworkInfoInput}
                aria-label="edit password"
                style={{ border: 'none', marginTop: '0px', outline: 'none' }}
                type="password"
                defaultValue={this.state.controls.password.value}
              />
            </p>
            <div className={showEditPwd ? '' : classes.HideEditPwd}>
              <div>
                <div>
                  {passInput}
                  <button
                    onClick={() => this.viewPassToggle()}
                    id="eyeIcon"
                    title="mask Password"
                    className={classes.ViewButton}
                  >
                    {eyePass}
                  </button>
                  <div
                    id="PassErrorMsg"
                    style={
                      this.state.isInvalidPassword
                        ? { color: 'red', fontSize: 12 }
                        : { display: 'none' }
                    }
                  >
                    Space is only allowed in between the characters. The
                    following characters are not allowed $ {'<'} {'>'} ` \ ^ & ;
                    " '
                  </div>
                </div>
              </div>
              <div className={classes.Spacer}></div>

              <label>Confirm WiFi Password </label>
              <div>
                {confPassInput}
                <button
                  onClick={() => this.viewConfPassToggle()}
                  id="eyeIcon"
                  title="mask Password"
                  className={classes.ViewButton}
                >
                  {eyeConfPass}
                </button>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '6px 5px 10px 5px',
                  }}
                  onClick={this.submitPasswordHandler}
                  id="savePassword"
                  title="Change Password"
                  disabled={
                    this.state.controls.password.value.length <= 7 ||
                    this.state.controls.password.value.length >= 30 ||
                    !this.isValidPassword(this.state.controls.password.value) ||
                    this.state.controls.password.value ===
                    this.state.originalPassword ||
                    this.state.controls.password.value !==
                    this.state.controls.confirmPassword.value
                  }
                >
                  <FaCheck color={this.state.controls.password.value.length <= 7 ||
                    this.state.controls.password.value.length >= 30 ||
                    !this.isValidPassword(this.state.controls.password.value) ||
                    this.state.controls.password.value ===
                    this.state.originalPassword ||
                    this.state.controls.password.value !==
                    this.state.controls.confirmPassword.value ? 'grey' : 'green'} />
                </button>

                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '0px',
                    paddingLeft: '1px',
                  }}
                  onClick={this.cancelPwd}
                  id="cancelPwd"
                  title="Cancel Password"
                >
                  <FaTimes color={'red'} />
                </button>
              </div>
              <div className={classes.Helper}>8-29 characters</div>
              {this.state.controls.password.value !==
                this.state.controls.confirmPassword.value &&
                <span id='PassMatchWarning' className={classes.CofirmPasswordMatch}>Password must match</span>
              }
              <div className={classes.Spacer}></div>
            </div>
            {isBroadcasting && (
              <div className={classes.broadcastBannerContainer}>
                <p className={classes.broadcastBannerTitle}>SIPWOW Account - WiFi disabled</p>
                <div className={classes.broadcastBadge}>
                  <BiSolidBarChartAlt2 className={classes.broadcastBadgeIcon} />
                  <span className={classes.broadcastBadgeText}>Not Broadcasting</span>
                </div>
              </div>
            )}

            <Modal
              show={this.state.confirmModal}
              modalClosed={this.confirmModalCancelHandler}
            >
              <Confirm
                id={'NetworkInfo'}
                action={this.state.action}
                result={this.state.result}
                confirm={this.confirmModalConfirmHandler}
                cancel={this.confirmModalCancelHandler}
                deviceGroupConfirmation
              />
            </Modal>
            {this.state.confirmNameModal && <Modal
              show={this.state.confirmNameModal}
              modalClosed={this.confirmModalCancelHandler}
              deviceNameConfirmationModal
            >
              {(this.props.checkingWan || (this.props.realWan &&
                this.props.realWan.connectionState &&
                this.props.realWan.connectionState === 'disconnected')|| (this.props.realWan &&
                  this.props.realWan.connectionState &&
                  this.props.realWan.connectionState === 'unavailable')) ?
                this.getConfirmationModalForDisconnected() : this.getConfirmNameModalBody()}
            </Modal>}
            <Modal
              show={this.state.specReadyConfirmModal}
              modalClosed={this.specReadyConfirmModalCancelHandler}
            >
              <SpecReadyConfirm
                toggleOn={this.state.specReadyToggle}
                confirm={this.specReadyConfirmModalConfirmHandler}
                cancel={this.specReadyConfirmModalCancelHandler}
              />
            </Modal>
            <Modal
              show={this.state.error}
              modalClosed={this.successErrorResetHandler}
            >
              <Error id={'NetworkInfoError'} errorStatus={this.props.errorStatus} showOldView />
            </Modal>
            <Modal
              show={this.state.success}
              modalClosed={this.successErrorResetHandler}
            >
              <Success id={'NetworkInfoSuccess'} />
            </Modal>
            <Modal
              show={this.state.serviceRestoreSuccess}
              modalClosed={this.successErrorResetHandler}
            >
              <Success id={'NetworkInfoSuccess'} message={`Service has been successfully restored.`}/>
            </Modal>
          </div>
        </Collapsible>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    specReadyConnectivity: state.spectrumReady.connectivity,
    account: state.settings.account,
    realSettings: state.settings.realSettings,
    realWan: state.wan.realWan,
    isDummy: state.auth.isDummy,
    settingsLoading: state.settings.loading,
    settingsLoaded: state.settings.loaded,
    wanLoading: state.wan.loading,
    wanLoaded: state.wan.loaded,
    success: state.settings.success,
    serviceRestoreSuccess: state.settings.serviceRestoreSuccess,
    error: state.settings.error,
    errorStatus: state.settings.errorStatus,
    checkingWan: state.wan.checkingWan,
    tenantData: state.wan.tenantData,
    staticIPConfigData: state.staticIPConfig.staticIPConfigData,
    staticIPConfigError: state.staticIPConfig.error,
    broadcastSettingsData: state.broadcastSettings.broadcastSettingsData,
    broadcastSettingsError: state.broadcastSettings.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeNamePass: (name, password, t) =>
      dispatch(actions.changeNamePass(name, password, t)),
    onResetSettingsErrorSuccess: () =>
      dispatch(actions.resetSettingsErrorSuccess()),
    onInitConnectivity: () => dispatch(actions.initConnectivity()),
    onMoveIn: () => {
      dispatch(actions.moveIn());
    },
    onMoveOut: () => dispatch(actions.moveOut()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(NetworkInfo, api));
